import { defineMessages } from 'react-intl'

export default defineMessages({
  addDomain: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelistField.AddDomain',
    defaultMessage: 'Add'
  },
  addedURLs: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelistField.AddedURLs',
    defaultMessage: 'Added URLs'
  },
  addressesLabel: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelistField.AddressesLabel',
    defaultMessage: 'Domains'
  },
  urlPlaceholder: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.MicroUI.DomainWhitelistField.UrlPlaceholder',
    defaultMessage: 'https://www.exampleurl.com/'
  }
})
